<template>
    <router-link :id="id" :to="{ name: linkTo}" :class="{'router-link-active' : setActive}">
        <li class="flex h-48 mb-8 w-full items-center justify-center relative group">
            <div class="active-link bg-secondary h-full w-4 rounded-r absolute left-0"></div>

            <tooltip :content="tooltip" offset="0,16" display="light">
                <button class="relative trans-ease text-white cursor-pointer hover:text-secondary flex flex-col items-center justify-center">
                    <svg-icon :class="iconSize" :type="icon"></svg-icon>
                    <tag
                        v-if="isNew"
                        display="secondary"
                        no-icon
                        class="mt-2 !py-2 px-8"
                    >
                        <span class="text-sm font-semibold">New</span>
                    </tag>
                </button>
            </tooltip>
        </li>
    </router-link>
</template>

<script>
import Tooltip from './Tooltip.vue';
import SvgIcon from '../ui/SvgIcon.vue';
import Tag from "../ui/Tag.vue";

export default {
    components: {Tag, SvgIcon, Tooltip},
    props: {
        id: String,
        icon: String,
        iconSize: {type: String, default:'w-24 h-24'},
        tooltip: String,
        linkTo: String,
        setActive: Boolean,
        isNew: Boolean,
    },
}
</script>

<style scoped>
.active-link {
    @apply hidden;
}

.router-link-active {
    &  .active-link {
        @apply block;
    }

    &  button:first-of-type {
        @apply text-secondary;
    }
}
</style>